import { storeToRefs } from 'pinia';
import { useSessionStore } from '@Stores';
import { useAToast } from '@Atoms';
import { GetAllSitesInfoService } from '@/modules/Entities/Shelter/modules/KennelManager/services';
import type { KennelManagerLabelsInterface } from '../../../Entities/Shelter/modules/KennelManager/types/kennel.types';

export default async function (locationKennelGroups: boolean = false) {
  const { shelterProfile } = storeToRefs(useSessionStore());
  if (!shelterProfile.value?.use_kennel_manager) return;

  const { notify, TOAST_TYPES } = useAToast();

  const TOAST_ERROR = {
    message: 'errors.generics.unknownIssue.message',
    title: 'errors.generics.unknownIssue.title',
    type: TOAST_TYPES.ERROR,
  };

  try {
    const result = await GetAllSitesInfoService(true);

    const maps = {
      sites: new Map(),
      buildings: new Map(),
      locations: new Map(),
      kennels: new Map(),
    };

    const groupedLocations = new Map();
    const groupedKennels = new Map();

    for (const site of result.data ?? []) {
      if (!site?._id) continue;
      maps.sites.set(site._id, { _id: site._id, label: site.label });

      for (const building of site.buildings ?? []) {
        if (!building?._id) continue;
        maps.buildings.set(building._id, { _id: building._id, label: building.label });

        for (const location of building.locations ?? []) {
          if (!location?._id) continue;
          maps.locations.set(location._id, { _id: location._id, label: location.label });

          if (locationKennelGroups) {
            if (!groupedLocations.has(building._id)) {
              groupedLocations.set(building._id, {
                label: building.label,
                _id: building._id,
                items: [],
              });
            }
            groupedLocations.get(building._id)?.items.push({
              _id: location._id,
              label: location.label,
            });
          }

          for (const kennel of location.kennels ?? []) {
            if (!kennel?._id) continue;
            maps.kennels.set(kennel._id, { _id: kennel._id, label: kennel.label });

            if (locationKennelGroups) {
              if (!groupedKennels.has(location._id)) {
                groupedKennels.set(location._id, {
                  label: location.label,
                  _id: location._id,
                  items: [],
                });
              }
              groupedKennels.get(location._id)?.items.push({
                _id: kennel._id,
                label: kennel.label,
              });
            }
          }
        }
      }
    }

    return {
      sites: [...maps.sites.values()],
      buildings: [...maps.buildings.values()],
      locations: locationKennelGroups
        ? [...groupedLocations.values()]
        : [...maps.locations.values()],
      kennels: locationKennelGroups ? [...groupedKennels.values()] : [...maps.kennels.values()],
    } as KennelManagerLabelsInterface;
  } catch {
    notify(TOAST_ERROR);
    return null;
  }
}
